module.exports = __webpack_public_path__ + "static/media/samGrimley.5bc55753.png";